import GuestlistTemplates from '../../../store/guestlists/templates';

angular
    .module('festzelt-os.modules.guestlists')
    .factory('GuestlistTemplates', [
        '$injector',
        ($injector) => new GuestlistTemplates({}, {
            injector: $injector
        })
    ]);



// WEBPACK FOOTER //
// ./src/app/modules/guestlists/store/templates.js